import styled from "styled-components";
import classNames from "classnames";
import Responsive from "./media-queries";

const Container = styled.div`
  width: 100%;
  padding: 0 10px;
  text-align: ${(props) => (props.textAlign ? props.textAlign : '')};

  ${Responsive.md} {
    padding: 0 ${(props) => props.theme.layout.gutter.md};
  }
  ${Responsive.lg} {
    padding: 0 ${(props) => props.theme.layout.gutter.lg};
  }
`;

export const Row = (props) => {
  const classes = classNames(`wrapper`, props.className);

  return (
    <div className={classes} style={props.style}>
      <Container className="container" textAlign={props.textAlign}>{props.children}</Container>
    </div>
  );
};
